import React from 'react'

const Day = (props) => {
  const { whiteLabelFontStyles } = props
  // const circleStyle = {
  //   borderRadius: '50%',
  //   border: '2px solid #c7c7c7',
  //   width: '30px',
  //   height: '30px',
  //   textAlign: 'center',
  //   fontSize: '16px',
  //   padding: '2px 0',
  // }
  const dotStyle = {
    borderRadius: '50%',
    border: '2px solid #c7c7c7',
    width: '8px',
    height: '8px',
    textAlign: 'center',
    fontSize: '16px',
  }
  const completed = {
    border: `4px solid ${
      (whiteLabelFontStyles && whiteLabelFontStyles.color) || '#9ac8b9'
    }`,
    backgroundColor:
      (whiteLabelFontStyles && whiteLabelFontStyles.color) || '#9ac8b9',
  }
  const skipped = {
    border: '4px solid #7d92a5',
    backgroundColor: '#7d92a5',
  }

  const scheduled = {
    border: `1px solid  ${
      (whiteLabelFontStyles && whiteLabelFontStyles.color) || '#9ac8b9'
    }`,
  }
  if (props.status === 'completed') {
    return (
      <div
        className="circle-with-text-below"
      >
        <div className="day">{props.day}</div>
        <div className="date">{props.date.getDate()}</div>
        <div style={{ ...dotStyle, ...completed }} />
      </div>
    )
  }
  if (props.status === 'skipped') {
    return (
      <div
        className="circle-with-text-below"
      >
        <div className="day">{props.day}</div>
        <div className="date" style={props.styleProps}>
          {props.date.getDate()}
        </div>
        <div style={{ ...dotStyle, ...skipped }} />
      </div>
    )
  }
  if (props.status === 'scheduled') {
    return (
      <div
        className="circle-with-text-below"
      >
        <div className="day">{props.day}</div>
        <div className="date">{props.date.getDate()}</div>
        <div style={{ ...dotStyle, ...scheduled }} />
      </div>
    )
  }

  return (
    <div className="circle-with-text-below">
      <div className="day">{props.day}</div>
      <div className="date" style={props.styleProps}>
        {props.date.getDate()}
      </div>
    </div>
  )
}

export default Day
